document.addEventListener('DOMContentLoaded', function () {

  // loyalty page filled email
  if (window.location.href.indexOf("/loyalty") !== -1) {
  var urlParams = new URLSearchParams(window.location.search);
      
      if (urlParams.has('email')) {
          var email = urlParams.get('email');
          $("#email").val(email);
      } else {
          console.log('Email parameter not found in the URL.');
      }
  }


  // newsletter form custom functionality
  const emailInput = document.querySelector('.email-input-custom-newsletter');
  const button = document.querySelector('.newsletter-custom-button');

  if (!emailInput || !button) return;

  function isValidEmail(email) {
    // Simple and reliable email validation
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function handleNewsletterRedirect(event) {
    // Prevent Shopify form submit / any default button behavior
    event.preventDefault();
    event.stopPropagation();

    const email = emailInput.value.trim();

    if (!email) {
      alert('Please enter your email address.');
      emailInput.focus();
      return;
    }

    if (!isValidEmail(email)) {
      alert('Please enter a valid email address.');
      emailInput.focus();
      return;
    }

    // Redirect to loyalty page with email query param
    const targetUrl = '/a/loyalty?email=' + encodeURIComponent(email);
    window.location.href = targetUrl;
  }

  // Handle click on button
  button.addEventListener('click', handleNewsletterRedirect);

  // Optional: handle Enter key in input (if user presses Enter)
  emailInput.addEventListener('keydown', function (event) {
    if (event.key === 'Enter') {
      handleNewsletterRedirect(event);
    }
  });
});